import { render, staticRenderFns } from "./xglhc.vue?vue&type=template&id=20688c8c&"
import script from "./xglhc.vue?vue&type=script&lang=js&"
export * from "./xglhc.vue?vue&type=script&lang=js&"
import style0 from "./xglhc.vue?vue&type=style&index=0&id=20688c8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports